import DealReceipt from './DealReceipt';
export default DealReceipt;